function GTMHelper() {
    var self = this;

    // Send the standard addToCart event
    this.addToBasket = function(items, currency) {
        window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': currency,
                'add': {
                    'products': items
                }
            }
        });
    };

    // Send the standard removeFromCart event
    this.removeFromBasket = function(items, currency) {
        window.dataLayer.push({
            'event': 'removeFromCart',
            'ecommerce': {
                'currencyCode': currency,
                'remove': {
                    'products': items
                }
            }
        });
    };

    // Deal with a response from our basket endpoints
    this.handleBasketUpdate = function(payload) {
        if (payload.additions.length) {
            this.addToBasket(payload.additions, payload.currency);
        }
        if (payload.removals.length) {
            this.removeFromBasket(payload.removals, payload.currency);
        }
    };
};

Soho.GTM = new GTMHelper();
